// Icons
import RedeemOutlinedIcon from '@mui/icons-material/RedeemOutlined';
import QuizIcon from '@mui/icons-material/Quiz';
import StarsIcon from '@mui/icons-material/Stars';
import WalletIcon from '@mui/icons-material/Wallet';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import InfoIcon from '@mui/icons-material/Info';

// Pages
import ProfilePage from "../components/features/Profile/ProfilePage";
import TopUpPage from "../components/features/Profile/TopUpPage";
import UserProfileDetails from "../components/features/Profile/UserProfileDetails";
import EditProfile from "../components/features/Profile/EditProfile";
import IntroductionPage from "../components/features/Introduction/IntroductionPage";
import FAQs from "../components/features/FAQs/FAQs";
import CardDetailsPage from "../components/features/Profile/CardDetails";
import OrderDetailsPage from "../components/features/Orders/OrderDetailsPage";
import OrdersPage from '../components/features/Orders/OrdersPage';
import VouchersPage from '../components/features/Vouchers/Vouchers';
import PaymentSuccessPage from '../components/features/Profile/PaymentSuccessPage';

// Model
import { IRouteType } from "../models/IRouteType";
import RewardPointsPage from '../components/features/RewardPoints/RewardPointsPage';
import { PATH_NAME } from '../configs/pathName';
import WalletPage from '../components/features/Profile/WalletPage';

const appRoutes: IRouteType[] = [
    {
        index: true,
        path: PATH_NAME.MEMBER,
        element: <ProfilePage />,
        state: "Dashboard",
        sidebarProps: {
            displayText: "Wallet",
            icon: <WalletIcon />
        },
    },
    {
        path: "vouchers",
        element: <VouchersPage />,
        state: "Vouchers",
        sidebarProps: {
            displayText: "Vouchers",
            icon: <RedeemOutlinedIcon />
        }
    },
    {
        path: "orders",
        element: <OrdersPage />,
        state: "Orders",
        sidebarProps: {
            displayText: "Orders",
            icon: <ReceiptLongIcon />
        },
    },
    {
        path: "order_details/:orderId",
        element: <OrderDetailsPage />,
        state: "Orders",
    },
    {
        path: "topup",
        element: <TopUpPage />,
        state: "Dashboard",
    },
    {
        path: "profile",
        element: <UserProfileDetails />,
        state: "Dashboard",
    },
    {
        path: "edit_profile",
        element: <EditProfile />,
        state: "Dashboard",
    },
    {
        path: "introduction",
        element: <IntroductionPage />,
        state: "Introduction",
    },
    {
        path: "rewardpoints",
        element: <RewardPointsPage />,
        state: "Reward Points",
        sidebarProps: {
            displayText: "Reward Points",
            icon: <StarsIcon />
        },
    },
    {
        path: "faqs",
        element: <FAQs />,
        state: "FAQs",
        sidebarProps: {
            displayText: "FAQs",
            icon: <QuizIcon />
        },
    },
    {
        path: "introduction",
        element: <IntroductionPage />,
        state: "Introduction",
        sidebarProps: {
            displayText: "Tutorial",
            icon: <InfoIcon />
        },
    },
    {
        path: "card_details/:cardId",
        element: <CardDetailsPage />,
        state: "Dashboard",
    },
    {
        path: "payment_success",
        element: <PaymentSuccessPage />,
        state: "PaymentSuccess",
    },
    {
        path: "wallet",
        element: <WalletPage />,
        state: "Dashboard",
    },
];

export default appRoutes;